// import Main from './Main'

export default [
  { path: '/blog/posts', component: () => import('./components/ListaPosts'), name: 'blog.posts' }
]
